var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box9new"},[_c('div',{staticClass:"btn",on:{"click":_vm.openDetail}},[_vm._v("进入学习")])])}
var staticRenderFns = []

export { render, staticRenderFns }